<template>
  <div id="order">
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">订单 </li>
</ul>
</div>
</div>

<div style="margin:0 auto" class="widu">
订单列表
<table class="table table-bordered table-striped table-hover">
      <thead>        
  <tr bgcolor="#ffffff" id="table1" style="font-size:14px">
    <td><strong>订单号</strong></td>
    <td><strong>金额</strong></td>
    <td><strong>日期</strong></td>
    <td><strong>付款状态</strong></td>
    <td><strong>发货状态</strong></td>
    <td><strong>方式</strong></td>
     <td><strong>公司名称</strong></td>
    <td><strong>操作</strong></td>
  </tr>
      </thead>
      <tbody>
 <tr class="cp" v-for="row in diamonds">
          <td>{{row.order_id}}  </td>
          <td>{{row.sum}}</td>
<td>{{row.order_date}}</td>
<td>
<div v-if="row.status">
已付款
</div>
<div v-else>
未付款
</div>
</td>
<td>
<div v-if="row.huohuo">
已发货
</div>
<div v-else>
未发货
</div>
</td>

<td>
<div v-if="row.picked=='view'">
看货
</div>
<div v-if="row.picked=='purchase'">
购买
</div>
</td>

 <td>{{row.buyer_note}}</td>

 <td>  
<a v-bind:href="'/order/' + row.order_id">查看订单商品</a>
 </td>
</tr>
</tbody>
</table>
<div style="text-align:center;margin-top:20px;margin-bottom:20px">
</div>
</div>

<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                                <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>


  </div>
</template>

<script>

export default {
  name: 'Order',
  data(){
  return {
  title:"购物车",
  token:localStorage.authorization,
  url:'',
  cart_url:'https://www.giazh.com/auth/order',
  hl:'',
  tips:'',
  loading:false,
  diamonds:[]
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
     getData: function (type,value) {
     if(this.token){
		 this.url="https://www.giazh.com/auth/order";
		 }else{
		 this.url="https://www.giazh.com/auth/order";
		 }
          this.$http.post(this.url,{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.diamonds=data.body;
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				alert('已退出');
				//window.location.reload(true);
			      });
    },
     checkout: function () {
          this.$http.post("https://www.giazh.com/auth/order/add",{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('333',data);
	    if(data.body=='ok'){
	    this.$router.push('/order');
	    }
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				alert('已退出');
				//window.location.reload(true);
			      });
    }
  },
  components:{
  },
  created(){
	       if(this.token){
		 this.url="https://www.giazh.com/auth/vi";
		 }else{
		  this.url="https://www.giazh.com/api/vi";
		 }
		    this.getData();

  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}



</style>


// WEBPACK FOOTER //
// src/components/Order.vue